import {Color} from "three";
import * as THREE from "three";

function generateTexture() {

    const canvas = document.createElement( 'canvas' );
    canvas.width = 2;
    canvas.height = 2;

    const context = canvas.getContext( '2d' );
    context.fillStyle = 'white';
    context.fillRect( 0, 1, 2, 1 );

    return canvas;

}

//const texture = new THREE.CanvasTexture( generateTexture() );

export const MATERIAL_PROPS_DB = [


    {
        materialName: "GlassMat",
        glass: true,
        glassMatFunc: (envMap) => {
            return new THREE.MeshPhysicalMaterial({
                name: `GlassMat-MPM`,
                color: new THREE.Color(0xffffff),
                emissive :new THREE.Color( 0.20969663085937498, 0.21999999999999997, 0.21999999999999997 ),
                metalness: .01,
                roughness: 0,
                // alphaMap: texture,
                // alphaTest: 0.5,
                //envMap: envMap, //this.backgroundMap,
                envMapIntensity: .572,
                //depthWrite: false,
                transmission: 1, // use material.transmission for glass materials
                opacity: .34, // set material.opacity to 1 when material.transmission is non-zero
                transparent: true,
                //ior: 1.5,
                //specularIntensity: 1,
                //specularColor: 0xffffff,
                //  side: THREE.DoubleSide,
                //alphaMap: texture,
                toneMapped:false,
            });
        },
    },

    {
        materialName:"I_UV_01_MAT",
        toneMapped:'N',
    },
    {
        materialName:"I_UV_02_MAT",
        toneMapped:'N',

    },
    {
        materialName:"I_UV_03",
        toneMapped:'N',
    },
    {
        materialName:"I_UV_04",
        toneMapped:'N',
    },
    {
        materialName:"I_UV_05",
        toneMapped:'N',
    },
    {
        materialName:"I_UV_06",
        toneMapped:'N',
    },

    {
        materialName:"I_UV_07",
        toneMapped:'N',
    },
    {
        materialName:"Wall_UVT_02",
        toneMapped:'N',
        convertToBasicMaterial: 'Y',
    },


    {
        materialName:"FloorMat",
        aOIntensity:1.0117089080959614,

        envMapIntensity:1.8,


        roughness:0.42,
        // toneMapped:'N',

    },



    /* {
         materialName: "W01EP01G001_mat",
         convertToBasicMaterial: 'Y',
         toneMapped:'N',

     },*/

    {
        materialName: "PanelsOnGridEntrenceFrontMat",
        // convertToBasicMaterial: 'Y',
        toneMapped:'N',
        // aOIntensity:0.05,

    },
    {
        materialName: "WallText_UVT2",
        convertToBasicMaterial: 'Y',
        // toneMapped:'N',


    },






    {
        materialName:"ceiling_southW_white_mat",
        // aOIntensity:0.7562538705271811,
        aOIntensity:0.05 ,
        envMapIntensity:1.59,
        convertToBasicMaterial: 'Y',
        toneMapped:'N',
    },
    {
        materialName:"ManualTexture_01",
        // aOIntensity:0.7562538705271811,
      /*  aOIntensity:0.79 ,
        envMapIntensity:1.59,*/
        convertToBasicMaterial: 'Y',
        toneMapped:'N',
    },
    {
        materialName:"ReceptionTableMat",
        aOIntensity:0.3730713141740106,

    },
    {
        materialName:"ReceptionBigSofaMat",
        aOIntensity:0.8197745630296611,

    },
    {
        materialName:"CoffeTable01Mat",
        aOIntensity:0.8197745630296611,

    },

    {
        materialName:"InsidePillarMat",
        aOIntensity:0.8201176299193762,

        envMapIntensity:0.05091482087285474,
        toneMapped:'N',

    },
    {
        materialName:"Floor_mat",
        aOIntensity:0.71,
        envMapIntensity:0.954,
        // convertToBasicMaterial: 'Y',

        toneMapped:'N',
        roughness:0.3798121422934505,
        metalness:0.3265923427999546,

    },
    {
        materialName: "FrontDeskTextMat",
        aOIntensity: 0.9159132690076687,
    },

    {
        materialName: "All_steel_mat",
        aOIntensity: 0.5327307126544983,
        envMapIntensity:4.52137797832651,
    },
    {
        materialName:"ArchFenceMat",
        // aOIntensity:0.4369350735662057,
        // toneMapped:'N',
        aOIntensity:1.0,

        envMapIntensity:0.01,

        roughness:1,
        toneMapped:'N',
    },
    {
        materialName: "CeilingMat",
        aOIntensity: 0.3,
        toneMapped:'N',
        envMapIntensity: 0.8,
        convertToBasicMaterial: 'Y',
    },
    {
        materialName: "semiDarkGlassMat",
        toneMapped:'N',
        convertToBasicMaterial: 'Y',
    },
    {
        materialName: "ScrollsMainMat3",

        envMapIntensity: 4.9,
        roughness:0.7842826184440193,
        toneMapped:'N',

    },
    {
        materialName:"DoorWood",
        aOIntensity:0.4688669532623032,

        toneMapped:'N',

    },

    {
        materialName: "chairTableMat",
        aOIntensity:0.6604582314388885,
    },

    {
        materialName: "StairsFloorMat",
        aOIntensity: 0.8,
    },
    {
        materialName: "HDRIMaterial",
        toneMapped:'N',
    },
    {
        materialName:"Floor_outside_mat",
        aOIntensity:0.7243219908310835,

        envMapIntensity:1.01951517165448,

        roughness:0.3691681823947513,
        metalness:0.48625174128044224,

    },

    {
        materialName:"LongChair01FabricMat",
        aOIntensity:0.9159132690076687,
        envMapIntensity:0,
        toneMapped:'N',

    },
    {
        materialName:"TableLampTop",
        emmisiveColor: new THREE.Color(0xC79C68),
        emmissiveIntensity:1.9,
        toneMapped:'N',
    },
    {
        materialName: "ceilingLightMat2",
        aOIntensity: 0.6285263517427909,
    },

    {
        materialName:"PuxianLowBakedMat",
        aOIntensity:0.9797770283998637,
        envMapIntensity:4.968424294071875,
        roughness:0.8694342976336127,
        toneMapped:'N',

    },









    /*
[
{
 materialName:"PuxianLowBakedMat",
aOIntensity:0.9797770283998637,
emmisiveColor:
 new Color( 0, 0, 0 ),
emmissiveIntensity:1,
envMapIntensity:4.968424294071875,
lightMapIntensity:1,
roughness:0.8694342976336127,
metalness:1,
toneMapped:false,
color:
 new Color( 1, 1, 1 ),
 },

 ]

    */



]
